export default "__VITE_ASSET__d7ce2QyL__"